// 학년 상수 — 확인평가 계층 보기·보고서 등 신규 코드 공용.
// (기존 화면의 GRADE_OPTIONS 하드코딩은 전면 교체하지 않고 점진 전환한다.)

export const GRADES = ['중1', '중2', '중3']
